export enum ErrorCode {
  InvalidParamMissingDataField = 400001,
  InvalidParamInvalidDataField = 400002,
  InvalidParamTrackingMissingAppId = 400101,
  InvalidParamTrackingMismatchPlatform = 400102,
  InvalidParamTrackingAppIsPending = 400103,
  InvalidParamIamMissingClientId = 400201,
  InvalidParamIamInvalidClientId = 400202,
  InvalidParamLoyaltyInvalidClientId = 400130,

  LoyaltyMissingLoginConfig = 400402,

  PermissionDeniedTracking = 403101,
  PermissionDeniedIam = 403201,
  PermissionDeniedLoyalty = 403301,

  NotFoundOrganization = 404001,
  NotFoundProject = 404002,
  NotFoundPlatform = 404003,
  NotFoundMarket = 404004,
  NotFoundEnvironment = 404005,
  NotFoundApp = 404006,
  NotFoundAppVersion = 404007,
  NotFoundService = 404008,
  NotFoundServiceVersion = 404009,
  NotFoundModule = 404010,
  NotFoundModuleVersion = 404011,
  NotFoundServiceIntegration = 404012,
  NotFoundServiceIntegrationConfig = 404013,
  NotFoundConfigInServiceIntegration = 404014,
  NotFoundModuleIntegration = 404015,
  NotFoundModuleIntegrationConfig = 404016,
  NotFoundConfigInModuleIntegration = 404017,
  NotFoundServiceConnect = 404018,
  NotFoundUserInProject = 404020,
  NotFoundTrackingAppId = 404101,
  NotFoundNotificationAppId = 404110,
  NotFoundIamClientId = 404201,
  NotFoundPaymentMerchantCode = 404120,
  NotFoundPaymentTerminalCode = 404121,
  NotFoundLoyaltyIamAudience = 404130,
  NotFoundLoyaltyClient = 404131,

  ServerErrorInternalServer = 500,
  ServerErrorTrackingServerError = 500101,
  ServerErrorTrackingCannotFindCreatedApp = 500102,
  ServerErrorIamServerError = 500201,
}
